import { rest } from 'msw';

import { usersMock, fieldErrorsMock } from '../bulkInscription.mock';
import { API_REST_URL } from 'config/variables';

const lmsUrl = API_REST_URL;

const subscribeUsersToCourse = rest.post(`${lmsUrl}/test`, (req, res, ctx) => {
  return res(
    ctx.delay(1000),
    ctx.json({
      data: {
        users: usersMock,
        errors: fieldErrorsMock,
        count: 6,
      },
      status: 'success',
    }),
  );
});

export const bulkInscriptionsHandlers = [subscribeUsersToCourse];
